<template>
<div class="paginator">
  <div class="page-size-select-container">
      Show <chc-input
      class="page-size-select-input"
        v-model="pageSize"
        format="combo"
        :autoCompleteValues="pageCombo"
      ></chc-input> Entries
  </div>
  <div class="paginator-pages">
    <div class="paginator-button paginator-page-previous"
         :class="{'disabled': pageNumber === 1}"
         @click="movePrevious">
      <span>Previous</span>
    </div>
    <div class="paginator-button paginator-page" :class="{ 'active': num === pageNumber, 'paginator-page-number': typeof num == 'number' }" v-for="num in numberDisplay" v-bind:key="num" @click="moveTo(num)">
      <span>{{ num }}</span>
    </div>
    <div class="paginator-button paginator-page-next"
         :class="{'disabled': pageNumber === pages.length}"
         @click="moveNext">
      <span>Next</span>
    </div>
  </div>
</div>
</template>

<script>
/* eslint-disable */

export default {

  props: {

    source: {
      type: Array,
      default: () => []
    },
  },

  data() {
    return {
      index: 0,
      pageSize: 25,
      pageCombo: [
        {
          label: '5',
          value: 5
        },
        {
          label: '10',
          value: 10
        },
        {
          label: '25',
          value: 25
        },
        {
          label: '50',
          value: 50
        },
        {
          label: '100',
          value: 100
        },
      ],
    };
  },

  computed: {

    pages() {
      let data = this.source;

      let pages = this.getPages(data, this.pageSize);

      // need to reset the page number if the data length changes
      // otherwise the index will be outside the bounds of the data
      if (this.pageNumber > pages.length) {
        this.pageNumber = 1;
      }

      return pages;
    },

    pageNumber: {
      get() {
        return this.index + 1;
      },
      set(value) {
        this.index = value - 1;
        this.$emit("page-changed", value);
      }
    },

    data() {
      return this.pages[this.index];
    },

    numberDisplay() {
      let THRESHOLD = 10;
      let LENGTH_NEAR_END = 4;

      let pages = this.pages;
      let pageNumber = this.pageNumber;

      let display = [];
      if( pages.length > THRESHOLD ) {
        if( pageNumber <= LENGTH_NEAR_END ) {
          for (var i = 1; i <= LENGTH_NEAR_END + 1; i++) {
            display.push(i);
          }

          display.push('...');
          display.push(pages.length);
        } else if( pages.length - pageNumber < LENGTH_NEAR_END ) {
          display.push(1);
          display.push('...');

          for (var i = (pages.length - LENGTH_NEAR_END); i < pages.length + 1; i++) {
            display.push(i);
          }
        } else {
          display.push(1);
          display.push('...');
          display.push(pageNumber - 1);
          display.push(pageNumber);
          display.push(pageNumber + 1);
          display.push('...');
          display.push(pages.length);
        }
      } else {
        display = pages.length;
      }

      return display;
    }

  },

  methods: {

    movePrevious() {
      this.pageNumber -= this.pageNumber > 1 ? 1 : 0;
    },

    moveNext() {
      this.pageNumber += (this.pageNumber != this.pages.length) ? 1 : 0;
    },

    moveTo(pageNumber) {
      if (pageNumber > 0 && pageNumber <= this.pages.length) {
        this.pageNumber = pageNumber;
      }
    },

    getPages(array, pageSize) {
      let pages = [];
      let start = 0;
      let length = array.length;

      while (start < length) {
        let end = start + pageSize;

        if (length - start < pageSize) {
          end = start + (length - start);
        }

        let page = array.slice(start, end);

        pages.push(page);
        start += pageSize;
      }

      return pages;
    }

  }

}
</script>

<style lang="scss">
@import "../../style/variables";
@import "mixins";


.paginator {
    margin: 1rem 0;
    @include flexbox();
    @include align-items(center);
    @include justify-content(space-between);

    .paginator-pages {
      @include flexbox();
      @include align-items(center);
      @include justify-content(flex-end);

      .paginator-button {
        color: $link-color;
        padding: .25rem .5rem;
        &.active {
          color: $text-color;
        }
        &:hover {
          color: $yellow;
          border-bottom: 2px solid $yellow;
          cursor: pointer;
        }
        &.disabled {
          color: $text-color;
          &:hover {
            color: $text-color;
            border: none;
            cursor: default;
          }
        }
        &.paginator-page-previous,
        &.paginator-page-next {
          padding: .25rem 0;
        }
      }


      .paginator-page-next {
          margin-left: 10px;
          cursor: pointer;
      }

      .paginator-page-previous {
          margin-right: 10px;
          cursor: pointer;
      }
    }

    .page-size-select-container {
        @include flex(0);
        min-width: 200px;
        font-weight: bold;
        text-transform: uppercase;
        display: flex;
        align-items: center;

        .page-size-select-input {
          width: 3rem;
          text-align: center;
        }
    }
    .field {
      margin-bottom: 0;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/Datatables/AppPaginator.vue